import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col items-center gap-1" }
const _hoisted_2 = ["href", "aria-label", "onClick"]

import Icons from '@/components/subcomponents/Icons.vue'
import { INavBarItem } from '@/models/navbar'
import { useLanguageStore } from '@/stores/LanguageStore'

import NavBarRailGroup from './NavBarRailGroup.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBarRail',
  props: {
    model: {}
  },
  setup(__props: any) {



const languageStore = useLanguageStore()

const hasChildren = (item: INavBarItem) => Boolean(item.items && item.items.length > 0)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.model, (item) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: item.label
      }, [
        (item.to)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: item.to,
              custom: ""
            }, {
              default: _withCtx(({ href, navigate, isActive }) => [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: href,
                  "aria-label": _unref(languageStore).t(item.label),
                  class: _normalizeClass([
            'flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-md transition-colors',
            isActive
              ? 'bg-[var(--p-primary-100)] dark:bg-[var(--p-primary-800)]'
              : 'hover:bg-surface-100 dark:hover:bg-surface-800',
          ]),
                  onClick: navigate
                }, [
                  _createVNode(Icons, {
                    icon: item.icon,
                    class: "shrink-0 font-bold"
                  }, null, 8, ["icon"])
                ], 10, _hoisted_2)), [
                  [
                    _directive_tooltip,
                    _unref(languageStore).t(item.label),
                    void 0,
                    { right: true }
                  ]
                ])
              ]),
              _: 2
            }, 1032, ["to"]))
          : (hasChildren(item))
            ? (_openBlock(), _createBlock(NavBarRailGroup, {
                key: 1,
                item: item
              }, null, 8, ["item"]))
            : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})